var map = {
	"./About": 1356,
	"./About-1.jpg": 512,
	"./About-2.png": 2575,
	"./About-3.png": 3558,
	"./About.js": 1356,
	"./Appointment": 944,
	"./Appointment.js": 944,
	"./Cockroach-1.jpg": 7092,
	"./Cockroach.jpg": 6886,
	"./Count": 1518,
	"./Count.jpg": 5200,
	"./Count.js": 1518,
	"./Doctor.jpg": 3844,
	"./Find": 6578,
	"./Find.js": 6578,
	"./Footer": 4539,
	"./Footer.js": 4539,
	"./Form": 2999,
	"./Form.js": 2999,
	"./Header": 7454,
	"./Header.js": 7454,
	"./Home": 4509,
	"./Home-2.jpg": 3709,
	"./Home.js": 4509,
	"./Jayapura.jpg": 7542,
	"./Kavya R.jpg": 8863,
	"./KavyaImage.jpeg": 9895,
	"./Nagaraju S.JPG": 4224,
	"./News": 1626,
	"./News.js": 1626,
	"./Niranjan.JPG": 1709,
	"./Our Services.png": 6075,
	"./Ourservices-1": 565,
	"./Ourservices-1.js": 565,
	"./Pest-1.jpg": 8759,
	"./Pest-2.jpg": 360,
	"./Pest-20.jpg": 258,
	"./Pest-3.jpg": 7525,
	"./Rodents.jpg": 6024,
	"./SSPC.jpg": 48,
	"./Sachin Walke .HEIC": 3376,
	"./Sachin Walke.jpg": 9025,
	"./Savitha S.jpg": 6302,
	"./Services": 1929,
	"./Services.js": 1929,
	"./Sharan.PNG": 9289,
	"./Sharanappa Y.JPG": 6746,
	"./Shobha D.JPG": 1431,
	"./Siddaraju M.jpg": 3381,
	"./Signup.png": 6257,
	"./Spiders.jpg": 9415,
	"./Team": 2196,
	"./Team.js": 2196,
	"./Termites.jpg": 6976,
	"./Testimonials": 2335,
	"./Testimonials.js": 2335,
	"./Why": 647,
	"./Why.js": 647,
	"./gloves.jpeg": 5872,
	"./news-1.jpg": 8866,
	"./news-2.jpg": 8093,
	"./news-3.jpg": 3200,
	"./teams.png": 6079,
	"./testi-1.jpg": 9110,
	"./testi-2.png": 3273,
	"./testi-3.png": 8448,
	"./testi-4.png": 7103,
	"./why-1.jpg": 7541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5856;